import { http } from './http';
import type { Connection, ColumnDesignInfo, DatabaseObjectInfo, CreateConnectionRequest } from '@/types/domain';

export const connectionsApi = {
  list: () =>
    http.get<Connection[]>('/connections').then(r => r.data),

  get: (id: string) =>
    http.get<Connection>(`/connections/${id}`).then(r => r.data),

  listObjects: (id: string, schema?: string) =>
    http.get<DatabaseObjectInfo[]>(`/connections/${id}/objects`, { params: { schema } })
      .then(r => r.data),

  create: (data: CreateConnectionRequest) =>
    http.post<Connection>('/connections', data).then(r => r.data),

  update: (id: string, data: CreateConnectionRequest) =>
    http.put<Connection>(`/connections/${id}`, data).then(r => r.data),

  test: (data: CreateConnectionRequest) =>
    http.post<{ success: boolean; message: string }>('/connections/test', data).then(r => r.data),

  testById: (id: string) =>
    http.post<{ success: boolean; message: string }>(`/connections/${id}/test`).then(r => r.data),

  getTableDesign: (id: string, schema: string, table: string) =>
    http.get<ColumnDesignInfo[]>(`/connections/${id}/design`, { params: { schema, table } }).then(r => r.data),

  getViewDefinition: (id: string, schema: string, view: string) =>
    http.get<{ sql: string }>(`/connections/${id}/view-definition`, { params: { schema, view } }).then(r => r.data.sql),
};
